<template>
  <router-view></router-view>
</template>
<script>
import { isSetting } from "./common/sbase";
import { resetURL, setUploadURL, setURL } from "../stempcore/src/sbase";
import URL from "./assets/conf/setting.json";
import { URLS, $subscriber, cr } from "fire-wind-water";
import service from "./services/article";

resetURL(URL);
setUploadURL(URL.template.api.ungateway.contentUrl);
setURL(URL.template.api.gateway.general + "/");
window.addEventListener("message", ev => {
  console.log("监听到postmessage的消息，如下：");
  console.log(ev);
  if (false === cr.isUndefined(ev.data.settingUrl))
    $subscriber.emit("loadConfig", [ev.data]);
});
if (!isSetting) {
  window.$sk.loading.show();
}

export default {
  name: "App",
  // mixins: [mixinsTemplate],
  created() {
    // let self = this;
    window.$sk.template.module(this);
    // if(window.$s_temp.jsonParams){
    //   self.getConfig();
    // }else {
    //   window.$s_temp.watch = function (c) {
    //     if (c.type === 'jsonParams') {
    //       self.getConfig();
    //     }
    //   };
    // }
    function convertArrayToObject(array, key) {
      const initialValue = {};
      return array.reduce((obj, item) => {
        return {
          ...obj,
          [item[key]]: item
        };
      }, initialValue);
    }
    $subscriber.subscribe("loadConfig", configs => {
      if (cr.isUndefined(configs)) {
        alert("数据加载错误，网络异常");
        return;
      }
      cr.each(configs, config => {
        let extras = [];
        let extra2Array = function(array, targetArray) {
          cr.each(array, function(d) {
            if (d.type === "element" || d.type === "css") {
              targetArray.push(d);
            } else {
              extra2Array(d.extras, targetArray);
            }
          });
        };
        extra2Array(config.extra, extras); //将有用的extra 递归便利到数组中
        let result = convertArrayToObject(extras, "attrName"); //改成key-object形式 方便调用
        //处理postmessage传来的数据与getconfig接口返回的数据格式不一致问题
        cr.each(result, item => {
          if (false === cr.isUndefined(item.display)) {
            if (
              item.display.defaultValue === "1" ||
              item.display.defaultValue === "true"
            )
              item.display.defaultValue = true;
            if (
              item.display.defaultValue === "0" ||
              item.display.defaultValue === "false"
            )
              item.display.defaultValue = false;
            if (item.display.value === "1" || item.display.value === "true")
              item.display.value = true;
            if (item.display.value === "0" || item.display.value === "false")
              item.display.value = false;
          }
        });
        $subscriber.emit("config-loaded", result);
      });
    });
  },
  methods: {
    getConfig(tenantId) {
      const configId = URLS.getURL("configId") || "";
      if (configId) {
        let param = {
          configId: configId,
          tenantId: tenantId
        };
        service.getConfig(param).subscribe(data => {
          if (data.result == 0) {
            $subscriber.emit("loadConfig", [data.content.configInfo.html[0]]);
            // setTimeout(()=>{
            //   window.$sk.loading.hide();//隐藏loading

            // },0)
          }
        });
      }
    },
    skUserEnd() {
      let json = window.$sk.template.get();
      this.getConfig(json.common.tenantId);
    }
  }
};
</script>

<style lang="scss"></style>
